import { useAuth } from "../context/AuthContext";

const ALL = ["companies", "billing", "support", "system"];

// Platform permission helper: the owner holds every permission.
export const usePerms = () => {
  const { user } = useAuth();
  const role = user?.role;
  const granted = role === "super_admin" ? ALL : user?.platform_perms || [];
  return {
    perms: ALL,
    isOwner: role === "super_admin",
    can: (perm) => granted.includes(perm),
  };
};
